// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3l-da","question":"styles_question__3xMR6","description":"styles_description__GAjpZ"};